import { render, staticRenderFns } from "./DepositAddTable.vue?vue&type=template&id=543f76f4"
import script from "./DepositAddTable.vue?vue&type=script&lang=js"
export * from "./DepositAddTable.vue?vue&type=script&lang=js"
import style0 from "./DepositAddTable.vue?vue&type=style&index=0&id=543f76f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports